<template>
  <v-row>
    <v-col cols="12" sm="10" md="5" lg="5" class="pb-0">
      <h1 class="mb-8">Получение данных из log файла</h1>
      <v-row>
        <v-col cols="12" sm="10" md="8" lg="6"  class="py-0">
          <v-text-field
            flat
            label="название файла"
            outlined
            prepend-inner-icon="mdi-math-log"
            v-model="nameFile"
            dense
            type="string"
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0 mb-6">
          <v-btn
            color="success"
            class="text-none"
            dark
            @click="getLogs"
          >
            Получить
          </v-btn>
        </v-col>
        <v-col cols="3" class="py-0 mb-6">
          <v-btn
            color="success"
            class="text-none"
            :disabled="logs.length < 1"
            @click="downloadReportLogsPage"
          >
            Скачать
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="pb-3 pt-0">
      <v-card>
        <v-card-title>
          <span>Поиск</span>
          <v-col cols="12" sm="10" md="10" lg="9">
            <v-text-field
              v-model="filterContent"
              label="Поиск по содержанию"
              dense
              autocomplete="chrome-off"
              hide-details
            ></v-text-field>
          </v-col>
          <v-btn
            :disabled="logs.length < 1"
            color="primary"
            dense
            class="btn px-7 text-none"
            @click.prevent="filteredLogs"
          >
            Поиск
          </v-btn>
        </v-card-title>
        <v-data-table
          class="table mt-2"
          :headers="headers"
          :items="filteredLogs"
          :footer-props="{
            showFirstLastPage: true,
          }"
        >
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import cp1251Mixin from '@/mixins/cp1251Encode';

export default {
  name: 'ApartmentPayment',
  mixins: [cp1251Mixin],
  data: () => ({
    nameFile: '',
    filterContent: '',
    logs: [],
    headers: [
      {
        text: 'line',
        value: 'line',
      },
      {
        text: 'content',
        value: 'content',
      },
    ],
  }),
  created () {
  },
  computed: {
    ...mapGetters({
    }),
    filteredLogs () {
      let logs = this.logs;

      if (this.filterContent) {
        logs = logs.filter(item => {
          return item.content.toLowerCase().includes(this.filterContent.toLowerCase());
        });
      }

      return logs;
    },
  },
  methods: {
    ...mapActions({
      getLogsNameFile: 'DeviceLog/getLogsNameFile',
    }),
    downloadReportLogsPage () {
      const lines = [];
      this.logs.forEach((item) => {
        const line = [
          item.line, item.content,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'Logs.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getLogs () {
      if (this.nameFile !== '') {
        this.getLogsNameFile({
          nameFile: this.nameFile,
        })
          .then((data) => {
            this.logs = data;
            this.$flash_success('Успешно!');
          })
          .catch((e) => {
            console.error(e);
            this.logs = [];
            this.$flash_warning('Произошла ошибка во время получения данных');
          });
      } else {
        this.$flash_danger('Введите название файла');
      }
    },
  },
};
</script>
